import "../createPassword/index.scss";

import React from "react"
import { connect } from "react-redux"
@connect((store) => {
    return {
        socket: store.socket.container,
    }
})

export default class ActivationExpired extends React.Component {
    back() {
        window.location.replace('/');
    }
    render() {
        return (
            <div id="login">
                <div class="form-signin">
                    <div class="border-top"></div>  
                    <div class="logo logo-header" style={{ maxWidth: "100%"}}>
                        <img src="/images/cloudcfo-logo-colored-icon-beside-text.png" class="img-responsive" style={{height: '27px'}} />
                        <h1 class="">Activation link expired</h1>
                        {/* <a class="btn btn-lg btn-violet btn-block mt20" onClick={() => this.back()}>Back</a> */}
                    </div>
                    <div class="activationLinkNote text-center">
                        <div class="mb50 text-black">
                            Submit a ticket through our <a href="https://www.notion.so/cloudcfoph/278db69b4c2d8030b354f2ef567de446?pvs=106" target="_blank">Helpdesk</a>
                            <br/>
                            or
                            <br/>
                            Email us at <a style={{ pointerEvents: "none"}}>support@cloudcfo.ph</a>
                        </div>

                        {/* <span style={{ color: "#999999"}}>App version: 1.2.9</span> */}
                    </div>
                </div>
            </div>
        )
    }
}